import { login, adminLogin } from '@/api/auth';
import { getUser, changeUserInfo } from '@/api/user';
import { handleError } from "@/utils/common";

import VueCookies from "vue-cookies";

const userStore = {
	namespaced: true,
	state: {
		user: {},
		userId: VueCookies.get("userId") || "",
		ndbTkn: VueCookies.get("ndbTkn") || "",
		reauthToken: null,
	},
	getters: {
		isLogin(state) {
			return state.ndbTkn !== "";
		},
		getId(state) {
			return state.userId;
		},
		getNdbTkn(state) {
			return state.ndbTkn;
		},
		getUserNm(state) {
			return state.user.nm;
		},
		getUserEmail(state) {
			return state.user.email;
		},
		getUserCell(state) {
			return state.user.cell;
		},
		getUserDept(state) {
			return state.user.dept;
		},
	},
	mutations: {
		SET_USER(state, user) {
			state.user = user;
		},
		SET_USER_ID(state, userId) {
			state.userId = userId;
		},
		SET_NDB_TKN(state, ndbTkn) {
			state.ndbTkn = ndbTkn;
		},
		SET_REAUTH_TKN(state, token) {
			state.reauthToken = token;
		},
		CLEAR_ALL(state) {
			state.user = {};
			state.userId = "";
			state.ndbTkn = "";
			state.reauthToken = null;
		},
		CLEAR_REAUTH_TKN(state) {
			state.reauthToken = null;
		},
	},
	actions: {
		async FETCH_USER({ state, commit }) {
			if (Object.keys(state.user).length === 0) {
				try {
					const param = {
						userId: state.userId,
					};
					const { data } = await getUser(param);
					commit("SET_USER", data.data);
				} catch (error) {
					handleError(error);
				}
			}
		},
		async LOGIN({ commit }, loginUserData) {
			const { data } = await login(loginUserData);
			commit("SET_USER", data.data.user);
			commit("SET_USER_ID", data.data.id);
			commit("SET_NDB_TKN", data.data.ndbTkn);
			commit("CLEAR_REAUTH_TKN");
			VueCookies.set("userId", data.data.id, "1h");
			VueCookies.set("ndbTkn", data.data.ndbTkn, "1h");
		},
		async ADMIN_LOGIN({ commit }, param) {
			commit("LOGOUT");

			const { data } = await adminLogin(param);
			commit("SET_USER", data.data.user);
			commit("SET_USER_ID", data.data.id);
			commit("SET_NDB_TKN", data.data.ndbTkn);
			commit("CLEAR_REAUTH_TKN");
			VueCookies.set("userId", data.data.id, "1h");
			VueCookies.set("ndbTkn", data.data.ndbTkn, "1h");
		},
		LOGOUT({ commit }) {
			commit("CLEAR_ALL");
			VueCookies.remove("userId");
			VueCookies.remove("ndbTkn");
		},
		REFRESH_USER({ commit }, data) {
			commit("SET_NDB_TKN", data.data.ndbTkn);
			VueCookies.set("ndbTkn", data.data.ndbTkn, "1h");
		},
		async CHANGE_USER_INFO({ commit }, param) {
			const { data } = await changeUserInfo(param);
			commit("SET_USER", data.data);
		},
		SET_REAUTH({ commit }, token) {
			commit("SET_REAUTH_TKN", token);
		},
		CLEAR_REAUTH({ commit }) {
			commit("CLEAR_REAUTH_TKN");
		},
	},
};

export default userStore;
